<template>
  <div class="dt-menu">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.documents') }}</label>
    <multi-select v-model='selectedDocs' :getter='getDocumentTypes' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      selectedDocs: [],
    }
  },
  computed: {
    selectedDocIds() {
      return this.selectedDocs.map(c => c.id)
    },
    predicateQuery() {
      return this.predicate ? 'filters[document_type_id_in]' : 'filters[document_type_id_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[document_type_id_in]']
      delete newQuery['filters[document_type_id_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedDocIds })

      this.$router.push({ query: newQuery })
    },
    getDocumentTypes(params) {
      return this.listStore.getDocumentTypes(params)
    },
  }
}
</script>
<style lang="sass" scoped>
.dt-menu
  width: 200px
  padding: 10px
  .float-right
    margin-top: 10px
  select
    margin-bottom: 10px
label
  display: block
</style>
